import { defineStore } from 'pinia';
import apiFetch from '@wordpress/api-fetch';

export const useCityPopulationRangesStore = defineStore('city-population-ranges', {
  state: () => ({
    ranges: [],
    activeRanges: [],
  }),

  actions: {
    loadRanges(params = {}) {
      this.ranges = [];

      const query = new URLSearchParams();

      if (params.lang) {
        query.append('lang', params.lang);
      }

      return apiFetch({
        path: `/wp-json/ebus/market/city-population-ranges?${query.toString()}`,
      }).then((data) => {
        this.ranges = data;

        return data;
      }).catch((error) => {
        console.log('Error: ', error);  
      });
    },

    toggleRange(rangeSlug) {
      const index = this.activeRanges.indexOf(rangeSlug);

      if (index === -1) {
        this.activeRanges.push(rangeSlug);
      } else {
        this.activeRanges.splice(index, 1);
      }
    },

    resetActiveRanges() {
      this.activeRanges = [];
    },
  },
});
